import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import autoBind from 'react-autobind';

import FooterV2 from 'ui/common/rebranding/components/Footer/Footer';

// import brand from 'resources/brand';
import links from './messages';

import classnames from 'classnames';

class Footer extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  renderFooter() {
    const { className, intl: { formatMessage } } = this.props;

    return (
      <div
        className={classnames({
          'bg-white': true,
          [className]: true,
        })}
      >
        <FooterV2
          columnItemsOne={[
            {
              link: links.home.url,
              title: formatMessage(links.home.messages.name),
              isTargetBlank: false,
            },
          ]}
          columnItemsTwo={[
            {
              link: links.about.url,
              title: formatMessage(links.about.messages.name),
              isTargetBlank: false,
            },
            {
              link: links.contact.url,
              title: formatMessage(links.contact.messages.name),
              isTargetBlank: false,
            },
          ]}
          columnItemsThree={[
            {
              link: links.assessment.url,
              title: formatMessage(links.assessment.messages.name),
              isTargetBlank: false,
              isSamePage: true,
            },
            {
              link: links.faq.url,
              title: formatMessage(links.faq.messages.name),
              isTargetBlank: false,
            },
          ]}
          // socialNavItems={[
          //   {
          //     link: links.about.url,
          //     title: formatMessage(links.about.messages.name),
          //     isTargetBlank: false,
          //   },
          //   {
          //     link: links.faq.url,
          //     title: formatMessage(links.faq.messages.name),
          //     isTargetBlank: false,
          //   },
          //   {
          //     link: links.contact.url,
          //     title: formatMessage(links.contact.messages.name),
          //     isTargetBlank: false,
          //   },
          // ]}
          // copyrightText={formatMessage(brand.copyRight.messages.name)}
          // newsLetterText={formatMessage(brand.newsLetter.messages.name)}
          footerBottomNavItems={[
            // {
            //   link: brand.termsOfUse.currentVersion.url,
            //   title: formatMessage(brand.termsOfUse.currentVersion.messages.name),
            //   isTargetBlank: false,
            // },
            {
              link: links.privacy.url,
              title: formatMessage(links.privacy.messages.name),
              isTargetBlank: false,
            },
          ]}
        />
      </div>
    );
  }

  render() {
    return <div>{this.renderFooter()}</div>;
  }
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/ui/app/layout/footer/index.js